import { forwardRef, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Select, TextField, Typography, Zoom } from "@mui/material";
import { blue } from "@mui/material/colors";
import { dateUsaToInd, getCurrentDate } from "../frames/common";
import { validPrice } from "../booking/booking_halper";
import { paidClinet } from "./invoice_halper";

const Transition = forwardRef(function Transition(props, ref) {
    return <Zoom ref={ref} {...props} />;
});
const cu_date = getCurrentDate();

const CashPayment = ({ client, open, onClose, onSuccess }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [inputErrors, setInputErrors] = useState({});

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSelfClose = () => {
        if (isLoading) return;
        setInputErrors({});
        setError("");
        onClose();
    }

    const handleSelfSuccess = (e) => {
        setInputErrors({});
        onSuccess(e);
    }

    const handleSelfSubmit = (event) => {
        event.preventDefault();

        const frm_data = new FormData(event.currentTarget);
        const pay_date = dateUsaToInd(frm_data.get("pay_date"));
        const amount = frm_data.get("amount");
        const p_method = frm_data.get("p_method");
        const p_num = frm_data.get("p_num");

        var flag = true;
        if (__error_handler(validPrice(amount) && amount > 5, "amount", "Payment amount must be greter than ₹1.")) {
            flag = false;
        }
        if (flag) {
            const _json = { "client": client, "pay_amt": amount, "pay_method": p_method, "bank_trn": p_num, "trn_date": pay_date };
            setIsLoading(true);
            paidClinet(_json).then((res) => {
                setIsLoading(false);
                handleSelfSuccess(_json);
            }).catch((err) => {
                setIsLoading(false);
                setError(err.message);
                console.error(err);
            });
        }
    }

    if (client === null || open === false) return "";
    return (
        <Dialog open={open} onClose={handleSelfClose} TransitionComponent={Transition} component="form" onSubmit={handleSelfSubmit}>
            <DialogTitle color="secondary">Payment made by <strong>{client}</strong></DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                        <Typography variant="caption">Payment Note</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField size="small" variant="outlined" name="pay_date" defaultValue={cu_date} fullWidth error={inputErrors.pay_date} type="date" slotProps={{ htmlInput: { max: cu_date, min: "2014-04-01" } }} helperText={inputErrors.pay_date} placeholder="Date" label="Payment Date" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField size="small" variant="outlined" name="amount" fullWidth autoFocus error={inputErrors.amount} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 9999999 } }} helperText={inputErrors.amount} placeholder=" ₹" label="Payment Amount" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl size="small" fullWidth helperText={inputErrors.p_method} error={inputErrors.p_method}>
                            <InputLabel id="payment-method">Method</InputLabel>
                            <Select labelId="payment-method" id="payment-method" label="Method" name="p_method" defaultValue={"NEFT"}>
                                <MenuItem value={"NEFT"}>NEFT</MenuItem>
                                <MenuItem value={"UPI"}>UPI</MenuItem>
                                <MenuItem value={"Cheque"}>Cheque</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField size="small" variant="outlined" name="p_num" fullWidth error={inputErrors.p_num} type="text" helperText={inputErrors.p_num} placeholder="Transaction Number" label="Transaction Number" />
                    </Grid>
                </Grid>
            </DialogContent>
            {isLoading ? <LinearProgress color="secondary" /> : ""}
            <DialogActions>
                <Typography variant="caption" color="error">{error}</Typography>
                <Button onClick={handleSelfClose} color="warning" variant="outlined">Cancle</Button>
                <Button variant="contained" disabled={isLoading} color="secondary" type="submit">Pay</Button>
            </DialogActions>
        </Dialog>
    );
};

export default CashPayment;
